module.exports = __webpack_public_path__ + "static/media/51.b14d00d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/51.svg
// module id = 158
// module chunks = 0